import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import styled, { keyframes, css } from 'styled-components';

import { clientStore } from 'apps/client/app';

export const ProgressBar = observer(
  ({ visible = false, bgColor = null, position }) => {
    const { loading, posting } = clientStore;
    return (
      <Bar
        visible={visible || loading || posting}
        position={position}
        bgColor={bgColor}
      />
    );
  },
);

const shiftRightwards = keyframes`
  0% { transform: translateX(-100%); }
  50% { transform: translateX(0); }
  100% { transform: translateX(100%); }
`;

const shiftRightwardsVisible = css`
  animation: ${shiftRightwards} 1.2s ease-in-out infinite;
`;

const Bar = styled.div`
  position: ${props => props.position};
  top: 0;
  left: 0;
  right: 0;
  height: ${props => (props.visible ? '1px' : '0px')};
  z-index: 20000;
  background-color: ${props => props.bgColor || props.theme.color.primaryLight};
  ${props => (props.visible ? shiftRightwardsVisible : 'animation: initial;')};
  animation-delay: 0s;
  transition: opacity 600ms ease-in-out, height 600ms ease-in-out;
  opacity: ${props => (props.visible ? '1' : '0')};
`;

ProgressBar.propTypes = {
  clientStore: PropTypes.object,
  position: PropTypes.string,
};

ProgressBar.defaultProps = {
  position: 'fixed',
};
